/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBooleanCondition
 */
export interface ControlBooleanCondition {
    /**
     * 
     * @type {string}
     * @memberof ControlBooleanCondition
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBooleanCondition
     */
    question_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlBooleanCondition
     */
    value: boolean;
}

/**
 * Check if a given object implements the ControlBooleanCondition interface.
 */
export function instanceOfControlBooleanCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question_id" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlBooleanConditionFromJSON(json: any): ControlBooleanCondition {
    return ControlBooleanConditionFromJSONTyped(json, false);
}

export function ControlBooleanConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBooleanCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'question_id': json['question_id'],
        'value': json['value'],
    };
}

export function ControlBooleanConditionToJSON(value?: ControlBooleanCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'question_id': value.question_id,
        'value': value.value,
    };
}

